/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Screen_FleetInputs */

const vi_station_screen_fleet = /** @type {(inputs: Station_Screen_FleetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định vị xe`)
};

/**

* @param {Station_Screen_FleetInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_screen_fleet = /** @type {((inputs?: Station_Screen_FleetInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Screen_FleetInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_screen_fleet(inputs)
});